import React, { useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import * as serviceWorker from "./serviceWorker";

import NextApp from "./nextApp";
import "./index.css";
import { ToggleProvider } from "./context/contextProvider";
//firebase Auth

class AppMain extends React.Component {
  render() {
    return <NextApp />;
  }
}
// Wrap the rendering in a function:
const render = (Component) => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppMain />,
    document.getElementById("root")
  );
};

// Render once
render(
    <AppMain />
);
// ReactDOM.render(<Root />, document.getElementById("root"));

serviceWorker.unregister();
